import Vue from 'vue'
import App from './App.vue'
import AOS from 'aos'
import './stylus/main.styl'
import "aos/dist/aos.css"
import router from './router'
import vuetify from '@/plugins/vuetify'
import './styles/index.scss'
import axios from 'axios'
import store from './store'
import i18n from './i18n'

/* import VideoBackground from 'vue-responsive-video-background-player' */

Vue.config.productionTip = false

/* Vue.use(VideoBackground) */

new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  axios,
  computed: {
    ViewComponent () {
      const matchingView = router[this.currentRoute]
      return matchingView
        ? require('./pages/' + matchingView + '.vue')
        : require('./pages/404.vue')
    },
  },
  created () {
    AOS.init()
    },
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount()
  window.addEventListener('popstate', () => {
  this.app.currentRoute = window.location.pathname
})

